import { HashRouter, Route, Routes } from 'react-router-dom';

import ErrorBoundary from '@/component/helper/ErrorBoundary';
import { GlobalStyle } from '@/component/helper/GlobalStyle';
import ApiError from '@/component/route/ApiError';
import Config from '@/component/route/Config';
import NotFound from '@/component/route/NotFound';

import { COMMON_ROUTES } from '@/config/route';

import { StoreProvider } from './redux/store';

import Entry from './page/Entry';

import { APP } from './config/app';
import { EXTERNAL_LINK_URL } from './config/externalLinkUrl';

function App() {
  return (
    <StoreProvider>
      <HashRouter basename=''>
        <GlobalStyle />
        <ErrorBoundary>
          <Routes>
            <Route path={APP.ROUTES.ENTRY} element={<Entry />} />

            <Route
              path={COMMON_ROUTES.CONFIG}
              element={<Config APP={APP} EXTERNAL_LINK_URL={EXTERNAL_LINK_URL} />}
            />
            <Route
              path={`${COMMON_ROUTES.API_ERROR}/:errCode`}
              element={<ApiError />}
            />
            <Route
              path={COMMON_ROUTES.NOT_FOUND}
              element={<NotFound redirectRoute={APP.ROUTES.ENTRY} />}
            />
          </Routes>
        </ErrorBoundary>
      </HashRouter>
    </StoreProvider>
  );
}

export default App;
